module.exports = __webpack_public_path__ + "static/media/07_quadcopter_floor.689a5559.jpg";